<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';
import { sitePrefix } from '../useEventSignup.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const event = inject('tiqCurrentEvent', null);
// A visitor never meets the slot's placeholder: with no real event
// to render it draws nothing, and only the editor keeps the stand-in.
const editing = inject('tiqEditorCanvas', false);

const title = computed(() => event?.title || 'Event title');
// The design's event detail opens on the event's type in mono caps
// above the headline. It comes off the event, not the block config,
// so a template author has nothing extra to fill in.
const tag = computed(() => event?.tag || event?.audience || '');
const align = computed(() => (['left', 'center', 'right'].includes(props.config.align) ? props.config.align : 'left'));
// The way back. Same prefix rule as every other site link: /site/{org}
// on the app host, bare on the organization's own domain.
const eventsHref = computed(() => `${sitePrefix()}/events`);
</script>

<template>
    <section v-if="event || editing" :id="config.anchor_id || null"
             class="th-block th-sec th-sec--tight th-etitle"
             :class="`is-align-${align}`"
             :style="styleVars(config)">
        <div class="th-wrap th-etitle__inner">
            <a class="th-back th-etitle__back" :href="eventsHref">&#8592; All events</a>
            <p v-if="tag" class="th-eyebrow th-etitle__tag">{{ tag }}</p>
            <h1 class="th-h1 th-h1--article">{{ title }}</h1>
        </div>
    </section>
</template>

<style scoped>
.th-etitle__inner { max-width: 820px; }
.th-etitle__back { display: block; }
.th-etitle__tag { margin-bottom: 14px; }
.th-etitle.is-align-center { text-align: center; }
.th-etitle.is-align-center .th-etitle__inner { margin-left: auto; margin-right: auto; }
.th-etitle.is-align-right { text-align: right; }
.th-etitle.is-align-right .th-etitle__inner { margin-left: auto; }
.th-etitle .th-h1 { margin-bottom: 0; }
</style>
